import { Tier, MarketPrice, BulkPrice } from '../../types/shared/Tier';

import ensureObject from './ensureObject';

function getDefaultTier(): Tier {
  return {
    id: '0',
    name: 'Default Pricing',
    simple_pricing: true,
    price_per_date: 0,
    base_price: 0,
    tax_rate: 0,
    base_price_is_tax_exempt: false,
    markets: {},
  };
}

function normalizeBulkPrice(price: { [key: string]: unknown }): BulkPrice {
  return {
    id: typeof price.id === 'string' ? price.id : '',
    min_date_count:
      typeof price.min_date_count === 'number' ? price.min_date_count : 0,
    per_date: typeof price.per_date === 'number' ? price.per_date : 0,
  };
}

function normalizeBulkPrices(input: unknown): Array<BulkPrice> {
  let inputList: Array<unknown> = Array.isArray(input) ? input : [];
  let outputList: Array<BulkPrice> = [];
  for (let item of inputList) {
    let bulkPrice = ensureObject(item);
    if (bulkPrice) {
      outputList.push(normalizeBulkPrice(bulkPrice));
    }
  }
  return outputList;
}

function normalizeMarket(market: { [key: string]: unknown }): MarketPrice {
  return {
    per_date: typeof market.per_date === 'number' ? market.per_date : 0,
    bulk: normalizeBulkPrices(market.bulk),
  };
}

function normalizeMarkets(markets: { [id: string]: unknown }) {
  let output: {
    [id: string]: MarketPrice;
  } = {};
  for (let marketID of Object.keys(markets)) {
    let market = ensureObject(markets[marketID]);
    if (market) {
      output[marketID] = normalizeMarket(market);
    }
  }
  return output;
}

function normalizePriceTier(tier: { [key: string]: unknown }): Tier {
  let markets = ensureObject(tier.markets);
  return {
    id: typeof tier.id === 'string' ? tier.id : '',
    name: typeof tier.name === 'string' ? tier.name : '',
    form_field_id:
      typeof tier.form_field_id === 'string' ? tier.form_field_id : null,
    form_field_value: tier.form_field_value,
    base_price: typeof tier.base_price === 'number' ? tier.base_price : 0,
    tax_rate: typeof tier.tax_rate === 'number' ? tier.tax_rate : 0,
    base_price_is_tax_exempt: !!tier.base_price_is_tax_exempt,
    simple_pricing:
      typeof tier.simple_pricing === 'boolean' ? tier.simple_pricing : true,
    price_per_date:
      typeof tier.price_per_date === 'number' ? tier.price_per_date : 0,
    markets: markets ? normalizeMarkets(markets) : {},
  };
}

function normalizePriceTiers(input: unknown): Array<Tier> {
  let inputList: Array<unknown> = Array.isArray(input) ? input : [];
  let firstTier: Tier | null | undefined;
  let otherTiers: Array<Tier> = [];
  for (let item of inputList) {
    let inputTier = ensureObject(item);
    if (inputTier) {
      let normalizedTier = normalizePriceTier(inputTier);
      if (normalizedTier.id === '0') {
        firstTier = normalizedTier;
      } else {
        otherTiers.push(normalizedTier);
      }
    }
  }
  if (firstTier == null) {
    firstTier = getDefaultTier();
  }
  return [firstTier, ...otherTiers];
}

export default normalizePriceTiers;
